import * as React from 'react';

import { StepCard } from '../StepCard';
import { NBSP } from '../../../../constants/symbols';

import * as styles from './styles.css';

export const StepCards: React.FC = () => {
  return (
    <div className={styles['step_cards']}>
      <div className={styles['step_card']}>
        <StepCard number={1}>
          Указываете адрес, загружаете документ, подтверждающий право собственности, выписку из ЕГРН от собственника и
          фото паспорта продавца.
        </StepCard>
      </div>
      <div className={styles['step_card']}>
        <StepCard number={2}>
          В течение трёх рабочих дней юристы{NBSP}присылают отчёт на{NBSP}электронную почту.
        </StepCard>
      </div>
    </div>
  );
};

StepCards.displayName = 'StepCards';
